/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./animation-form.vue?vue&type=template&id=2d495d02&scoped=true&"
import script from "./animation-form.vue?vue&type=script&lang=ts&"
export * from "./animation-form.vue?vue&type=script&lang=ts&"
import style0 from "./animation-form.vue?vue&type=style&index=0&id=2d495d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d495d02",
  null
  
)

export default component.exports